/**
 * The Ink Share lockup.
 *
 * Two variants of each asset ship: the artwork as drawn, and one with the navy
 * swapped for a near-white, because the navy in the wordmark and the pen nib
 * all but vanishes against dark paper. Which one shows is decided in CSS from
 * the `data-theme` attribute, since the app has its own paper switch that is
 * independent of the operating system's.
 *
 * Sizes are handed to CSS as custom properties rather than written as inline
 * pixels, so a media query can shrink the lockup on a narrow screen. Inline
 * styles would win over any stylesheet and the header would stay too wide for
 * a phone.
 */

const HEIGHTS = {
  sm: { mark: 28, word: 16 },
  md: { mark: 44, word: 25 },
  lg: { mark: 92, word: 44 },
} as const;

export default function Brand({
  size = 'md', showWordmark = true,
}: {
  size?: keyof typeof HEIGHTS;
  showWordmark?: boolean;
}) {
  const h = HEIGHTS[size];
  return (
    <span
      className="brand"
      role="img"
      aria-label="Ink Share"
      style={{
        '--brand-mark-base': `${h.mark}px`,
        '--brand-word-base': `${h.word}px`,
      } as React.CSSProperties}
    >
      <span className="brand__mark" />
      {showWordmark ? <span className="brand__word" /> : null}
    </span>
  );
}
